// src/components/ChatLayout.jsx
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSocket } from "../../../context/SocketContext"; 
import ChatListUI from "./ChatListUI";
import Message from "./Message";

export default function ChatLayout() {
  const [params] = useSearchParams();
  const chatId = params.get("chatId");
  const { setCurrentChat } = useSocket(); 

  useEffect(() => {
    setCurrentChat(chatId);
  }, [chatId, setCurrentChat]);

  return (
    <div className="flex w-full h-screen overflow-hidden bg-white">
      <div className="flex-shrink-0">
        <ChatListUI />
      </div>

      <div className="flex flex-1 flex-col min-h-0">
        {chatId ? (
          <Message />
        ) : (
          <div className="flex flex-1 items-center justify-center text-gray-500">
            Select or start a chat
          </div>
        )}
      </div>
    </div>
  );
}